// extracted by mini-css-extract-plugin
export default {"modalHeader":"style_modalHeader__3H0b0","textTitle":"style_textTitle__C5EE4","buttons":"style_buttons__WTzp1"};